<template>
  <div>
    <div class="relation-rule-tit">
      <em class="rule-step del-sel-rule iconshuzi iconfont" />
      <strong class="relation-rule-name">{{ $t('message["1370"]') }}</strong>
      <span>{{ $t('message["207"]') }}</span>
      <a-select
        class="relation-orign-sel"
        :placeholder="infoFromTit"
        :default-value="item.fieldkey"
        @change="handleChange"
      >
        <a-select-option
          v-for="(item2) in orginDatas"
          :key="item2.fieldkey"
          :value="item2.fieldkey"
        >
          {{ item2.fieldname }}
        </a-select-option>
      </a-select>
      <a
        class="del-rule-item"
        href="javascript:;"
        @click="DelRuleItem"
      >{{ $t('message["962"]') }}</a>
    </div>
    <div>
      <div class="rule-info-list">
        <add-select-text
          v-for="(val, key) in item.relaterule"
          :key="key"
          :datas="datas"
          :val-key="key"
          :value="val"
          :item="item.relaterule"
          :index="index"
        />
      </div>
      <div
        v-if="!isFull"
        class="add-rule-box"
      >
        {{ $t('message["61"]') }}
        <a-button
          class="add-rule-btn"
          @click="addSelectItem"
        >
          {{ $t('message["1190"]') }}
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import AddSelectText from './AddSelectText'
import { cloneDeep } from 'lodash'
import { mapState, mapGetters } from 'vuex'
export default {
  components: {
    AddSelectText
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      lists: {}
    }
  },
  computed: {
    ...mapState('config/relation', ['orginDatas', 'treeItemObj']),
    ...mapGetters('config/relation', ['currentData']),
    datas () {
      const { lists } = this
      const cloneLists = cloneDeep(lists)
      const { item } = this
      const arr = Object.keys(item.relaterule) || []
      arr.forEach((item, index) => {
        for (let key in cloneLists) {
          if (key === item) {
            cloneLists[key].disabled = true
          }
        }
      })
      item.ruleDatas = cloneLists
      return item.ruleDatas
    },
    isFull () {
      const len = Object.keys(this.item.relaterule).length
      const len2 = Object.keys(this.datas).length
      return len === len2
    },
    relaterule () {
      const arr = []
      Object.keys(this.item.relaterule).forEach((item, index) => {
        let obj = {}
        obj[item] = Object.values(this.item.relaterule)[index]
        arr.push(obj)
      })
      return arr
    },
    infoFromTit () {
      return this.$t('message["1370"]')
    }
  },
  created () {
    this.getSelectLists(this.item.fieldkey)
  },
  methods: {
    async handleChange (val, option) {
      this.item.ruleDatas = {}
      this.item.relaterule = {}
      this.item.fieldkey = val
      this.getSelectLists(val)
    },
    getSelectLists (val) {
      const { orginDatas } = this
      for (let key in orginDatas) {
        if (orginDatas[key].fieldkey === val) {
          this.lists = orginDatas[key].child
        }
      }
    },
    addSelectItem () {
      const { datas } = this
      let obj = {}
      for (let key in datas) {
        if (!datas[key].disabled) {
          obj[key] = datas[key]
        }
      }
      this.$set(this.item.relaterule, Object.keys(obj)[0], [])
    },
    DelRuleItem () {
      this.currentData.splice(this.index, 1)
    }

  }
}
</script>
<style lang="scss" scoped>
.relation-rule-tit {
  margin-top: 26px;
  position: relative;
  margin-bottom: 16px;
  .rule-step {
    font-size: 32px;
    color: #ccc;
    vertical-align: middle;
  }
  .relation-rule-name {
      font-weight: 600;
      margin: 0 20px;
  }
  .relation-orign-sel {
    width: 320px;
    margin-left: 20px;
  }
  .del-rule-item {
    position: absolute;
    top: 12px;
    right: 0;;
  }
}
.rule-info-list {
  margin-left: 30px;
  width: 528px;
}
.add-rule-box {
  margin: 0 0 47px 129px;
  .add-rule-btn {
    margin-left: 16px;
  }
}
</style>
